// extracted by mini-css-extract-plugin
module.exports = {"drawer":"MobileConnectWalletsDrawer_drawer__2xWGY","title":"MobileConnectWalletsDrawer_title__11H9x","visit":"MobileConnectWalletsDrawer_visit__1uHwv"};